
import React, { useCallback, useState } from "react";
import { Input } from "@cofano/cck";
import { debounce, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface AdminSettingsSearch {
	onSearch: (value: string) => void;
}

const AdminSettingsSearch = ({ onSearch }: AdminSettingsSearch) => {
	const [ value, setValue ] = useState("");

	const handleOnSearch = useCallback(
		debounce((v) => onSearch(v), 300),
		[],
	);

	const handleOnClear = () => {
		setValue("");
		onSearch("");
	};

	return (
		<div>
			<Input
				value={value}
				onChange={(event) => {
					setValue(event.target.value);
					handleOnSearch(event.target.value);
				}}
				placeholder='Search...'
				prefixIcon={<SearchIcon fontSize='small' />}
				suffixIcon={value ? (
					<IconButton size='small' onClick={handleOnClear}>
						<ClearIcon fontSize='small' />
					</IconButton>
				) :	(
					<React.Fragment />
				)}
			/>
		</div>
	);
};

export default AdminSettingsSearch;

